/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type JobCreateStatus = typeof JobCreateStatus[keyof typeof JobCreateStatus];


export const JobCreateStatus = {
  draft: 'draft',
  active: 'active',
} as const;
